module.exports = __webpack_public_path__ + "static/media/vuejs.2614a550.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/services/vuejs.svg
// module id = 388
// module chunks = 0